import React, { createContext, useState } from 'react';

// Create the UpdateContext
export const UpdateContext = createContext();

// Create a provider component
export const UpdateProvider = ({ children }) => {
  const [data, setData] = useState(null);  // Shared data across the app
  const [reloadTrigger, setReloadTrigger] = useState(false);  // Trigger reloads across the app

  // Function to update data and trigger reloading in certain situations
  const updateData = (newData) => {
    setData(newData);  // Update the data state
    setReloadTrigger((prevState) => !prevState);  // Toggle the reload trigger to force re-renders
  };

  return (
    <UpdateContext.Provider value={{ data, updateData, reloadTrigger }}>
      {children}
    </UpdateContext.Provider>
  );
};
